'use strict';

var _ = require('lodash');
var EffectiveValueFormulaService = function EffectiveValueFormulaService(utils) {
  /**
   *
   * @param type override value type - 'A' for absolute increase,
   * 'P' for percentage increase, 'O' for total override value
   * @param modelValue original value saved in the model
   * @param overrideValue user override value
   * @param factor calculated based on override's startRtp, used to reduce applied override value
   * @returns {*}
   */
  function calc(type, modelValue, overrideValue, factor) {
    var overrideValueWithoutFactor = overrideValue;
    if (!_.isNil(factor)) {
      overrideValue = overrideValue * factor;
    }
    if (type === 'A') {
      return !_.isNil(modelValue) ? modelValue + overrideValue : overrideValue;
    } else if (type === 'P') {
      return modelValue + overrideValueWithoutFactor / 100 * modelValue;
    } else {
      return overrideValue;
    }
  }
  function defaultWithMin(minimum) {
    return function (rowData, columnField) {
      var effectiveValue = formulasByField.defaultMethod(rowData, columnField);
      return effectiveValue < minimum ? minimum : effectiveValue;
    };
  }
  function effectiveGroupMaterializationRate() {
    return function (rowData) {
      var usrMatRate = parseFloat(rowData.userGroupMaterializationRate);
      var matRate = isNaN(usrMatRate) ? rowData.groupMaterializationRate : usrMatRate;
      return rowData.resHoldGroup * matRate;
    };
  }
  var formulasByField = {
    /**
     *
     * @param rowData data for the whole row where the value will be calculated
     * @param columnField field name for which the effective value should be calculated
     * calculated for the first time upon reading from database.
     * In that case the calculated value from BOM is the most important.
     * @returns {*}
     */
    defaultMethod: function defaultMethod(rowData, columnField) {
      var values = utils.getValues(rowData, columnField);
      var effectiveVal;
      if (values.user || values.user === 0) {
        if (values.calculated) {
          effectiveVal = values.calculated;
        } else {
          effectiveVal = calc(values.type, values.model, values.user, values.factor);
          rowData.markRenormalize = true;
        }
      } else {
        effectiveVal = values.model;
      }
      return effectiveVal;
    },
    effectiveMappedRemainingDemandFC: defaultWithMin(0),
    effectiveRegularRemainingDemandFC: defaultWithMin(0),
    effectiveLogicalModelCapacity: function effectiveLogicalModelCapacity(rowData) {
      var effectiveGroupBkgsCalculator = effectiveGroupMaterializationRate();
      var usrCapacity = parseFloat(rowData.userLogicalModelCapacity);
      var capacity = isNaN(usrCapacity) ? rowData.logicalModelCapacity : usrCapacity;
      var effGroupBookings = effectiveGroupBkgsCalculator(rowData);
      var effectiveValue = Math.ceil(capacity - effGroupBookings);
      return Math.max(effectiveValue, 0);
    },
    effectiveGroupMaterializationRate: effectiveGroupMaterializationRate(),
    showUpModel: function showUpModel(rowData) {
      var boardingRate = _.isNil(rowData.userBoardingRate) ? rowData.boardingRate : rowData.userBoardingRate;
      var cancellationRate = _.isNil(rowData.userCancellationRate) ? rowData.cancellationRate : rowData.userCancellationRate;
      return boardingRate * (1 - cancellationRate);
    },
    isManuallyControlled: function isManuallyControlled(rowData) {
      var value = _.isNil(rowData.userIsManuallyControlled) ? rowData.isManuallyControlled : rowData.userIsManuallyControlled;
      return value === true || value === 'true' ? 'Yes' : 'No';
    }
  };
  return {
    getFormula: function getFormula(fieldName) {
      return formulasByField[fieldName] || formulasByField.defaultMethod;
    }
  };
};
EffectiveValueFormulaService.$inject = ['OverridesUtilsService'];
module.exports = EffectiveValueFormulaService;